import { useCallback, useState } from "react";
import { SellerPubMissionStatusFilter } from "../../api/pub-mission";
import MissionFormPopup from "./components/mission-form-popup";
import Table from "./components/table/table";
import { useEventMission } from "./hooks/use-event-mission";
import * as S from "./styles";

const STATUS_TABS = [
  { label: "전체", value: SellerPubMissionStatusFilter.ALL },
  { label: "진행중", value: SellerPubMissionStatusFilter.IN_PROGRESS },
  { label: "종료", value: SellerPubMissionStatusFilter.ENDED },
];

const EventMission = () => {
  const {
    pubId,
    missionList,
    currentPage,
    setCurrentPage,
    totalPages,
    searchQuery,
    categoryFilter,
    statusFilter,
    handleSearchQueryChange,
    handleCategoryFilterChange,
    handleStatusFilterChange,
    refreshMissionList,
  } = useEventMission();

  const [editingMissionId, setEditingMissionId] = useState<number | undefined>();
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const closeFormPopup = useCallback(() => {
    setIsCreateOpen(false);
    setEditingMissionId(undefined);
  }, []);

  const isFormOpen = isCreateOpen || editingMissionId !== undefined;

  return (
    <S.EventMissionWrapper>
      <S.PageHeaderArea>
        <S.TitleRow>
          <S.Title>미션 관리</S.Title>
          <S.CreateButton
            type="button"
            onClick={() => setIsCreateOpen(true)}
          >
            + 미션 등록
          </S.CreateButton>
        </S.TitleRow>

        <S.TabRow>
          {STATUS_TABS.map((tab) => (
            <S.TabItem
              key={tab.value}
              type="button"
              $selected={statusFilter === tab.value}
              onClick={() => handleStatusFilterChange(tab.value)}
            >
              {tab.label}
            </S.TabItem>
          ))}
        </S.TabRow>
      </S.PageHeaderArea>

      <S.ContentScrollArea>
        <S.ContentBody>
          <S.TableSection>
            <Table
              list={missionList}
              pubId={pubId}
              categoryFilter={categoryFilter}
              searchQuery={searchQuery}
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              handleSearchQueryChange={handleSearchQueryChange}
              handleCategoryFilterChange={handleCategoryFilterChange}
              onRefresh={refreshMissionList}
              onEdit={(mission) => setEditingMissionId(mission.id)}
            />
          </S.TableSection>
        </S.ContentBody>
      </S.ContentScrollArea>

      {isFormOpen && pubId > 0 && (
        <MissionFormPopup
          pubId={pubId}
          missionId={editingMissionId}
          onClose={closeFormPopup}
          onSuccess={refreshMissionList}
        />
      )}
    </S.EventMissionWrapper>
  );
};

export default EventMission;
